export var LIMIT = 200;
export default (function (displayName, componentId) {
    var generatedClasses = {};
    var warningSeen = false;
    return function (className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= LIMIT) {
                // Unable to find latestRule in test environment.
                var parsedIdString = componentId ? " with the id of \"".concat(componentId, "\"") : '';
                console.warn("Over ".concat(LIMIT, " classes were generated for component ").concat(displayName).concat(parsedIdString, ".\n") +
                    'Consider using the attrs method, together with a style object for frequently changed styles.\n' +
                    'Example:\n' +
                    '  const Component = styled.div.attrs(props => ({\n' +
                    '    style: {\n' +
                    '      background: props.background,\n' +
                    '    },\n' +
                    '  }))`width: 100%;`\n\n' +
                    '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
});
//# sourceMappingURL=createWarnTooManyClasses.js.map